import { DEFAULT_CROP } from "../data/defaults";
import { SlotEditor } from "./ArtworksEditor";

/**
 * Editor of the «المشروع» + «ترتيب اللوحات المقترح» pages (ProjectPages.jsx).
 * onChange accepts the new project, or an updater (prev => next) for async upload results.
 */
export function ProjectEditor({ project, onChange, trackUpload, onLocate }) {
    const set = (patch) => onChange({ ...project, ...patch });
    const slotEditor = (key, label) => (<SlotEditor label={label} slot={project[key]} mode="frame" trackUpload={trackUpload} onChange={(slot) => set({ [key]: slot })} onUploaded={(image) => onChange((prev) => ({ ...prev, [key]: { image, crop: { ...DEFAULT_CROP } } }))}/>);
    return (<div className="project-editor">
      <p className="hint">صفحتين المشروع: اسم المشروع ووصفه وصورته (تطلع بالنص الأيسر).</p>
      <label className="field">
        <span>اسم المشروع</span>
        <input value={project.name} maxLength={200} placeholder="مثال: فندق بابل - اللوبي" onChange={(e) => set({ name: e.target.value })}/>
      </label>
      <label className="field">
        <span>وصف المشروع</span>
        <textarea rows={3} value={project.description} maxLength={1500} onChange={(e) => set({ description: e.target.value })}/>
      </label>
      <div className="project-slots">{slotEditor("photo", "صورة المشروع")}</div>
      <button type="button" className="link" onClick={() => onLocate("page-project")}>
        عرض صفحات المشروع ◎
      </button>

      <p className="hint">ترتيب اللوحات المقترح: نوع الرسم ووصف الترتيب وصورته.</p>
      <label className="field">
        <span>نوع الرسم</span>
        <input value={project.artType} maxLength={200} placeholder="مثال: تجريدي معاصر" onChange={(e) => set({ artType: e.target.value })}/>
      </label>
      <label className="field">
        <span>وصف ترتيب اللوحات</span>
        <textarea rows={3} value={project.artTypeDescription} maxLength={1500} onChange={(e) => set({ artTypeDescription: e.target.value })}/>
      </label>
      <div className="project-slots">{slotEditor("arrangement", "صورة الترتيب")}</div>
      <button type="button" className="link" onClick={() => onLocate("page-arrangement")}>
        عرض صفحة الترتيب ◎
      </button>
    </div>);
}
